//@flow
import React from 'react';
import { Container } from 'flux/utils';
import Fcc from '../../../components/FluxContainerConverter';
import UrlData from '../../Utils/url-data';
import _ from 'underscore';
import OfficeShell from '../../Shell/components/OfficeShell.react';
import OfficeHero2 from './OfficeHero2.react';
import EasySection from './EasySection.react';
import BeTheHeroSection from './BeTheHeroSection.react';
import WhyNatureboxSection from './WhyNatureboxSection.react';
import SnackFromHome from './SnackFromHome.react';
import OfficeVideo from './OfficeVideo.react';
import OfficeForm from './OfficeForm.react';
import OfficeLogos from './OfficeLogos.react';
import OfficeOfferings from './OfficeOfferings.react';
import ProductsStore from '../../Stores/Products/products';
import CategoriesStore from '../../Stores/MemberCategories/categories';
import { IfExperiment, IfNotExperiment } from '../../Experiments/components/ExperimentWrapper.react';

import type ProductModel from '../../Stores/Products/productModel';
import type { ContextRouter } from 'react-router';

type Props = ContextRouter;

type State = {
  filteredProducts:ProductModel[],
  shouldRedirect:boolean,
};

class OfficeApp extends React.Component<Props, State> {
  static getStores() {
    return [
      ProductsStore,
      CategoriesStore,
    ];
  }

  static calculateState(prevState:State):State {
    const products = ProductsStore.getProducts();
    const baseCategory = CategoriesStore.getCorporateCategories().models[0];
    const skus = _.first(baseCategory && baseCategory.getProductsSkus(), 8);

    return {
      filteredProducts: products.getProductsBySkus(skus),
      // See note in componentDidMount for why we always
      // redirect here
      shouldRedirect: true,
    };
  }

  componentDidMount() {
    // This component should never mount because of
    // routing updates that push all traffic to new
    // web-client for the office page. In event it does
    // because of client side routing, force reload
    // on mount.
    if (this.state.shouldRedirect) {
      const url = UrlData.getOfficeUrl();
      const search = UrlData.getSearch();
      const nextUrl = `${url}${search}`;
      UrlData.setCurrentUrl(nextUrl);
    }
  }

  render() {
    if (this.state.shouldRedirect) {
      return null;
    }

    return (
      <OfficeShell>
        <IfExperiment name="office_form_top">
          <OfficeForm heroVersion={true} />
        </IfExperiment>
        <IfNotExperiment name="office_form_top">
          <OfficeHero2 />
        </IfNotExperiment>
        <OfficeVideo />
        <SnackFromHome />
        <EasySection />
        <BeTheHeroSection products={this.state.filteredProducts} />
        <WhyNatureboxSection />
        <OfficeOfferings />
        <IfNotExperiment name="office_form_top">
          <OfficeForm />
        </IfNotExperiment>
        <OfficeLogos />
      </OfficeShell>
    );
  }
}

export default Container.create(Fcc.convert(OfficeApp), {
  pure: false,
  withProps: true,
});
